// extracted by mini-css-extract-plugin
export var copyableField = "_pi-4";
export var customerBadge = "_pi-0";
export var customerInfoTitle = "_pi-2";
export var details = "_pi-1";
export var dropdownContainer = "_pi-5";
export var dropdownImage = "_pi-6";
export var editAssigneeForm = "_pi-a";
export var editButton = "_pi-3";
export var email = "_pi-7";
export var hidden = "_pi-d";
export var input = "_pi-8";
export var saveButton = "_pi-b";
export var shopifyIcon = "_pi-c";
export var suggestionBadge = "_pi-e";
export var suggestionText = "_pi-f";
export var username = "_pi-9";